module.exports = __webpack_public_path__ + "static/media/materialspec.9adbd1e0.png";